import { render, staticRenderFns } from "./angebotSpedition.vue?vue&type=template&id=8cf7af16&"
import script from "./angebotSpedition.vue?vue&type=script&lang=js&"
export * from "./angebotSpedition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sschmidt/Arbeit/DevTool2025/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cf7af16')) {
      api.createRecord('8cf7af16', component.options)
    } else {
      api.reload('8cf7af16', component.options)
    }
    module.hot.accept("./angebotSpedition.vue?vue&type=template&id=8cf7af16&", function () {
      api.rerender('8cf7af16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/angebotSpedition.vue"
export default component.exports